import React from 'react';
import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { injectIntl } from "react-intl";
import { connect, } from "react-redux";
import { get, post, checkHttpStatus } from '../../utils/RestUtilsWithAxios';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button  from "@material-ui/core/Button";
import Dropdown from '../../components/Dropdown';
import { alertBox } from '../../components/BoxProvider';
import DownloadButtons from '../../components/PdfAndExcelDownloadButtons';
import {printThisPage} from '../../utils/ExportUtils';
import * as Globals from '../../constants/globals';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import {stableSort,getSorting} from '../../utils/ExportUtils';
import * as DownloadUtils from "../../utils/downloadUtils";
import FormControl from '@material-ui/core/FormControl';

import {
    GET_PLATFORM_ID_AND_NAME_MAP,
    GET_PLATFORM_CURRENCYLIST,
    GET_ALL_CURRENCIES,
    EXPORT_EXCEL_PLATFORM_CURRENCY_LIST,
} from '../../constants/uri';

/**
 * desc
 * @param a
 * @param b
 * @param orderBy
 * @return {number}
 */
function desc(a, b, orderBy) {
    return b[orderBy].toString().localeCompare(a[orderBy].toString());
   
}

/**
 * stableSort
 * @param array
 * @param cmp
 */
function stableSortTable(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

/**
 * getSorting
 * @param order
 * @param orderBy
 * @return {function(*=, *=): number}
 */
function getSortingTable(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const headStyles = makeStyles(theme => ({
    headFont: {
        fontSize: 13,
        fontWeight: 600
    },
    fontBold: {
        fontWeight: 600
    }
}));

/**
 * EnhancedTableHead
 * @param props
 * @return {*}
 * @constructor
 */
function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };
    const headClasses = headStyles();

    const headRows = [
        { id: 'platformName', numeric: false, disablePadding: false, label: props.intl.formatMessage({ id: "KVMKS.ACCOUNT.PLATFORM_NAME" }) },
        { id: 'currencyCode', numeric: false, disablePadding: false, label: props.intl.formatMessage({ id: "KVMKS.ACCOUNT.CURRENCY_CODE" }) },
        { id: 'currencyName', numeric: false, disablePadding: false, label: props.intl.formatMessage({ id: "KVMKS.ACCOUNT.CURRENCY_NAME" }) }
    ];

    return (
        <TableHead>
            <TableRow>
                {headRows.map(row => (
                    <TableCell
                        key={row.id}
                        align={row.numeric ? 'right' : 'left'}
                        padding={row.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === row.id ? order : false}
                        className={headClasses.headFont}
                    >
                        <TableSortLabel
                            active={orderBy === row.id}
                            direction={order}
                            onClick={createSortHandler(row.id)}
                        >
                            {
                                    <div>{row.label}</div>
                            }
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}
EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
};

const useStyles = makeStyles(theme => ({
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    fontSize13: {
        fontSize: 13
    },
    link: {
        color:'#aa3323'
    }
}));



const useSearchStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    paper: {
        marginBottom: theme.spacing(2),
        margin: 'auto',
        padding: 30,
        paddingTop: 20
    },
    formControl: {
        margin: theme.spacing(1),
    },
    group: {
        margin: theme.spacing(1, 0),
    },
    showButton: {
        marginTop: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            width: 200
        },
    },
    infoMsg: {
        marginBottom: theme.spacing(2),
        margin:'auto',
        padding: 30
    },
    textContainer: {
        marginBottom: theme.spacing(4),
        marginTop: theme.spacing(4),
    },

}))

/**
 * PlatformCurrencyList
 * @param props
 * @return {*}
 * @constructor
 */
function PlatformCurrencyList(props) {
    const searchClasses = useSearchStyles();
    const [members, setMembers] = useState([]);
    const [currencyList, setCurrencyList] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [selectedMember, setSelectedMember] = useState(null);
    const [dataFieldMessage, setDataFieldMessage] = useState("")
    const [platformCurrencyCodeAndNameData, setPlatformCurrencyCodeAndNameData] = useState([]);
    const [platformCurrencyCodeAndNameMap, setPlatformCurrencyCodeAndNameMap] = useState(null);
    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('currencyCode');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);       
    
    const headRows = [
        { id: 'platformName', numeric: false, disablePadding: false, label: props.intl.formatMessage({ id: "KVMKS.ACCOUNT.PLATFORM_NAME" }) },
        { id: 'currencyCode', numeric: false, disablePadding: false, label: props.intl.formatMessage({ id: "KVMKS.ACCOUNT.CURRENCY_CODE" }) },
        { id: 'currencyName', numeric: false, disablePadding: false, label: props.intl.formatMessage({ id: "KVMKS.ACCOUNT.CURRENCY_NAME" }) }
    ];

    /**
     * handleRequestSort
     * @param event
     * @param property
     */
    function handleRequestSort(event, property) {
        const isDesc = orderBy === property && order === 'desc';
        setOrder(isDesc ? 'asc' : 'desc');
        setOrderBy(property);
    }

    /**
     * handleChangePage
     * @param event
     * @param newPage
     */
    function handleChangePage(event, newPage) {
        setPage(newPage);
    }

    /**
     * handleChangeRowsPerPage
     * @param event
     */
    function handleChangeRowsPerPage(event) {
        setRowsPerPage(+event.target.value);
        setPage(0);
    }

    /**
     * prepareItemArr
     * @param trArray
     * @return {Array}
     */
    function prepareItemArr(trArray) {
        var setArray = [];
        for(var i=0;i<trArray.length;i++){
            var valueItem = {};
            valueItem.values = [];
            valueItem.values.push(trArray[i].platformName);
            valueItem.values.push(trArray[i].currencyCode);
            valueItem.values.push(trArray[i].currencyName);
           
            setArray.push(valueItem);
        }
        return stableSort(setArray,getSorting("asc",0));
    }

    React.useEffect(() => {
        get(GET_PLATFORM_ID_AND_NAME_MAP)
            .then(function (response) {
                console.log(response)
                const formatted = Object.entries(response.data).map(
                    ([key, value]) => ({ value:key, label:value })
                );
                setMembers(formatted);
            })
            .catch(function (error) {
                checkHttpStatus(error, props.intl);
            })
        get(GET_ALL_CURRENCIES)
            .then(function (response) {
                setCurrencyList(response.data);
            })
            .catch(function (error) {
                checkHttpStatus(error, props.intl);
            })
    }, []);

    /**
     * memberSelected
     * @param changedValue
     */
    function memberSelected(changedValue) {
        setSelectedMember(changedValue);
    }

    /**
     * retreivePledgeData
     */
    function retreivePledgeData() {
        if ((!selectedMember || selectedMember === '') && (!selectedCurrency || selectedCurrency === '')) {
            alertBox("", "Platform veya Kripto Varlık alanlarından en az birini seçiniz!",
                Globals.ALERT_WARNING, props.intl);
            return;
        }
        console.log(selectedMember)
        post(GET_PLATFORM_CURRENCYLIST, {platformId:selectedMember, currencyCode: selectedCurrency})
            .then(function (response) {               
                if (!response?.data || Object.keys(response.data).length === 0) {
                    setDataFieldMessage("Gösterilecek veri bulunmamaktadır.");
                    setPlatformCurrencyCodeAndNameData([]);
                    setPlatformCurrencyCodeAndNameMap(null);
                } else {
                    setPlatformCurrencyCodeAndNameMap(response.data)

                    setDataFieldMessage("");
                   
                    setPlatformCurrencyCodeAndNameData(response.data);
                }
            })
            .catch(function (error) {
                checkHttpStatus(error, props.intl);
            })
    }

    /**
     * downloadAsExcel
     * @param serviceName
     * @param fileName
     */
    function downloadAsExcel(requesyBody) {
        post(EXPORT_EXCEL_PLATFORM_CURRENCY_LIST,requesyBody)
            .then(function (response) {
                DownloadUtils.downloadFileByContentExcel(response.data, "PLATFORM KRİPTO VARLIKLARI RAPORU.xls", Globals.CONTENT_TYPE_EXCEL);
        })
        .catch(function (error) {
            checkHttpStatus(error,props.intl);
        })
    }
    return (
        <div className={searchClasses.root}>
            <Paper className={searchClasses.paper} >
                <Typography variant="h5">{"Platform Seçiniz"}</Typography>
                <Grid container direction="row" spacing={3}>
                    <Grid item xs={12} sm={4}>
                        <Dropdown name="members" id="members" title={"Platform Adı"} items={members}
                                  handleContainerChange={memberSelected} containerSelectedItem={selectedMember} />
                    </Grid>
                </Grid>
                 <Typography variant="h5">{"Kripto Varlık Seçiniz"}</Typography>
                <Grid container direction="row" spacing={3}>      
                     <Grid item xs={12} sm={4}>
                        <FormControl margin={"normal"}  undefined variant="outlined" fullWidth >
                        <Autocomplete
                            fullWidth     
                            options={currencyList}
                            value={selectedCurrency}
                            noOptionsText="Girilen kripto varlık bulunamadı"
                            onChange={(e, newValue) => setSelectedCurrency(newValue)}
                            renderInput={(params) => (
                                <TextField {...params} fullWidth label="Kripto Varlıklar" variant="outlined" />
                            )}
                        />
                         </FormControl>
                    </Grid>
                </Grid>
                <Grid container justify="flex-end">
                    <Button variant='contained' color='primary' size='large' onClick={retreivePledgeData}
                            className={searchClasses.showButton} fullWidth>
                        {props.intl.formatMessage({ id: "COMMON.BUTTON_SHOW" })}
                    </Button>
                </Grid>
            </Paper>
            <Paper className={searchClasses.paper}>
                {
                    platformCurrencyCodeAndNameData.length > 0 ?
                        <div>
                            <div className={classes.tableWrapper} id="accountTable">
                                <Table
                                    className={classes.table}
                                    aria-labelledby="tableTitle"
                                    size={'medium'}
                                >
                                    <EnhancedTableHead
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleRequestSort}
                                        rowCount={platformCurrencyCodeAndNameData.length}
                                        intl={props.intl}
                                    />
                                    <TableBody>
                                        {stableSortTable(platformCurrencyCodeAndNameData, getSortingTable(order, orderBy))
                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((row, index) => {
                                                return (
                                                    <TableRow
                                                        hover
                                                        tabIndex={-1}
                                                        key={'row' + index}
                                                    >
                                                        <TableCell align="left" key={"platformCode_" + index} id={"platformCode_" + index} className={classes.fontSize13}>{row.platformName}</TableCell>
                                                        <TableCell align="left" key={"currencyCode_" + index} id={"currencyCode_" + index} className={classes.fontSize13}>{row.currencyCode}</TableCell>
                                                        <TableCell align="left" key={"currencyName_" + index} id={"currencyName_" + index} className={classes.fontSize13}>{row.currencyName}</TableCell>
                                                    
                                                    </TableRow>    
                                                );
                                            })}
                                    </TableBody>
                                </Table>
                            </div>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={platformCurrencyCodeAndNameData.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                backIconButtonText={props.intl.formatMessage({ id: "TABLE.PAGINATION.PREVIOUS" })}
                                nextIconButtonText={props.intl.formatMessage({ id: "TABLE.PAGINATION.NEXT" })}
                                labelRowsPerPage={props.intl.formatMessage({ id: "TABLE.PAGINATION.PER_PAGE" })}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                            <DownloadButtons
                                pdfOnClick={() =>  { printThisPage(
                                                        prepareItemArr(
                                                        platformCurrencyCodeAndNameData
                                                        ),
                                                        headRows,
                                                        "Platform & Kripto Varlık Listesi" 
                                                    )}
                                }
                                excelOnClick={() =>  downloadAsExcel(platformCurrencyCodeAndNameMap)
                                }
                            />
                        </div>
                        
                        :
                        <Typography align='center' searchClasses={{h6: searchClasses.textContainer}} variant='h6'>
                            {dataFieldMessage}
                        </Typography>
                }
            </Paper>
            <Paper className={searchClasses.infoMsg}>
                <Grid container style={{backgroundColor: "white"}}>
                    <Typography display="inline" variant="subtitle1">
                        {"Bu sayfada yer alan bilgiler, ilgili platformlar tarafından MKK'ya iletilen verilerden oluşmaktadır. Uyumsuzluk durumunda verilerin düzeltilmesi için ilgili kripto varlık platformuna başvurabilirsiniz."}
                    </Typography>
                </Grid>
            </Paper>
        </div>
    )
}

/**
 * injectIntl
 */
export default injectIntl(
    connect(
        null,
    )(PlatformCurrencyList)
);